export class UpdateAttendeeCustomFields {
  public AttendeeHeaderIds: Array<number>;
  public Custom2: string;
  public Custom3: string;
  public Custom4: string;
  public Custom5: string;

  public constructor() {
    this.AttendeeHeaderIds = new Array<number>();
    this.Custom2 = '';
    this.Custom3 = '';
    this.Custom4 = '';
    this.Custom5 = '';
  }
}
